import { useEndSupportSession } from '@myrentalmate/api-client';
import { Alert, Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { formatDateTime } from '../lib/format';
import type { Me } from '../lib/me';

/** Always on screen during a support session, so nobody forgets whose records they're changing. */
export function SupportBanner({ me }: { me: Me }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const end = useEndSupportSession({
    mutation: {
      onSuccess: () => {
        // Nothing from the customer's records may linger on screen.
        queryClient.clear();
        navigate('/platform');
      },
    },
  });
  if (!me.support) return null;
  return (
    <Alert
      severity="warning"
      variant="filled"
      square
      action={
        <Button color="inherit" size="small" disabled={end.isPending} onClick={() => end.mutate()}>
          End session
        </Button>
      }
    >
      Support session: you're working in <strong>{me.support.org_name}</strong> until{' '}
      {formatDateTime(me.support.expires_at)}. Reason: {me.support.reason}
    </Alert>
  );
}
